<template>
<!-- 专题活动 -->
    <div class="events min-w">
        <div class="out">
            <div is='titlebox' :nav='nav' ></div>
        </div>
        <div class="main-in pb-1">
            <div class="align-start box f-row-start-l pinter" v-for="(item,kind) in list" :key='kind' @click.stop="$util.goPage('newDetail',32,item.id)">
                <div class="videobox f-row-c overf-h" @click.stop>
                    <videoBox :itemPlayTip='item.playTip' :file='item.file?item.file.split(",")[0]:""' @onChangeVideo='onChangeVideo' :index='kind'></videoBox>
                </div>
                <div class="cont">
                    <div class="title line4">{{item.title||''}}</div>
                    <!-- <div class="font-1">{{item.cont||''}}</div> -->
                    <div class="btn f-row-c">查看详情</div>
                </div>
                
            </div>
        </div>
         <!-- 分页 -->
        <div class="pages">
            <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
           nav: [
                {
                    label:'党建服务',
                    path:'/partyService',
                    type:14
                },
                {
                    label:'试听课件',
                    path:'/listeningTestList',
                    type:31
                }
            ],
            list:[],
            total: 0,
            pageNo:1,
            pageSize:15,
        };
    },

    created() {
        this.getActivity()
    },

    methods: {
        onChangeVideo(e){
            for(var i=0;i<this.list.length;i++){ 
                if(i==e.index){ 
                this.$set(this.list[e.index],'playTip',e.playTip)
                }else{ 
                this.$set(this.list[e.index],'playTip',!e.playTip)
                }
            }
            
        },
        getActivity(){//试听课件
          var param = {
            pageNo: this.pageNo,//分页
            pageSize: this.pageSize,
            msgType: 39
          }
          this.$get('/web/information/list', param).then(res => {
            this.list = res.result.records;
            this.total = res.result.total;
          })
        //     var param={
        //         pageNo:this.pageNo,//分页
        //         pageSize:this.pageSize,
        //         pictureType:0
        //     }
        // //    this.$get('/web/home/getLasBatchList',param).then(res=>{
        // //        this.list=res.result.records;
        // //        this.total= res.result.total
        // //     })
        //     this.list=[];
        //     this.total=3
        //     for(var i=0;i<=2;i++){
        //         this.list.push({
        //             createBy: "admin",
        //             createTime: "2021-07-14 14:01:35",
        //             id: "1415189711865233410",
        //             isVisible: "0",
        //             isVisible_dictText: "是",
        //             msgState: "1",
        //             msgState_dictText: "已发布",
        //             msgType: "8",
        //             msgType_dictText: "试听课件",
        //             putTime: "2021-07-14 14:01:40",
        //             title: "实现中华民族伟大复兴是海内外中华儿女共同的梦",
        //             cont:'学好用好《习近平谈治国理政》第三卷 推动中国海油高质量发展迈上新台阶',
        //             fileUrl:require('./../../assets/img/video/dome.mp4'),
        //             updateBy: "admin",
        //             updateTime: "2021-07-14 14:01:40",
        //         })
        //     }

        },
        handleSizeChange(val) {
            this.$util.goTop()
            this.pageSize=val;
            this.getActivity();
        },
        handleCurrentChange(val) {
            this.$util.goTop()
            this.pageNo=val;
            this.getActivity();
        },
    },
};
</script>

<style lang="scss" scoped>
.events{
    background-color: #fff;
    margin: auto;
    .out{
        max-width: 1300px;
        margin: auto;
    }
    .pages{
        text-align: center;
        margin: 30px auto 30px;
    }
}
.box{
    width: 100%;
    position: relative;
    margin-top: 25px;
    color: #333333;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    .videobox{ 
        width: 404px;
        height: 261px;
        background: #333333;
        position: relative;
        display: flex;  
    }
    .cont{ 
        box-sizing: border-box;
        padding-left: 74px;
        padding-top: 53px;
        padding-bottom: 22px;
        width: calc(100% - 414px);
        box-sizing: border-box;
        .title{
            font-size: 20px;
            margin-bottom: 41px;
        }
        .btn{
            margin-top: 63px;
            width: 120px;
            height: 32px;
            font-size: 16px;
            border: 1px solid #E50112;
            color: #E50112;
            border-radius: 15px;
        }
    }
    
}

</style>